import { Directive, Input, OnInit } from '@angular/core'
import { NgControl } from '@angular/forms'
import { CsSelectTableComponent } from '../cs-select-table.component'
import { AddressSelectorTypes, configAddressSelectModel, VssUiConfig } from 'projects/vss-ui/src/public-api'

@Directive({
  selector: '[addressCustomSelector]'
})
export class AddressCustomSelectorDirective implements OnInit {

  referenceId!: any
  referenceObject!: any
  addressType!: AddressSelectorTypes

  @Input() set asType(value: AddressSelectorTypes) {
    this.addressType = value
    this.switchApi()
  }

  @Input() set asReferenceObj(value: any | undefined) {
    this.referenceObject = {
      page: 0,
      size: 100,
      ...value
    }
    this.switchApi()
  }

  @Input() set asReferenceId(value: any | undefined) {
    this.referenceId = value
    this.switchApi()
  }

  switchApi() {
    if(
      !(Object.values(AddressSelectorTypes)).includes(this.addressType)
    ) return
    this.viewCsSelect.checkDisable = (o) => false
    this.viewCsSelect.options = []
    this.control.reset()
    switch (this.addressType) {
    case AddressSelectorTypes.areaStore:
      this.apiAreaByStore()
      break
    case AddressSelectorTypes.country:
      this.setupApiCountry()
      break
    case AddressSelectorTypes.commune:
      if ({
        ...this.referenceObject,
        referenceId: this.referenceId
      }) this.setupApiCommuneId()
      else {
        this.viewCsSelect.optionList = [{
          value: 0,
          label: 'Vui lòng chọn quận/huyện trước'
        }]
        this.viewCsSelect.checkDisable = (o) => true
      }
      break
    case AddressSelectorTypes.district:
      if ({
        ...this.referenceObject,
        referenceId: this.referenceId
      }) this.setupApiDistrict()
      else {
        this.viewCsSelect.optionList = [{
          value: 0,
          label: 'Vui lòng chọn tỉnh/thành trước'
        }]
        this.viewCsSelect.checkDisable = (o) => true
      }
      break
    case AddressSelectorTypes.province:
      if ({
        ...this.referenceObject,
        referenceId: this.referenceId
      }) this.setupApiProvince()
      else {
        this.viewCsSelect.optionList = [{
          value: 0,
          label: 'Vui lòng chọn quốc gia trước'
        }]
        this.viewCsSelect.checkDisable = (o) => true
      }
      break
    case AddressSelectorTypes.communeStore:
      if (this.referenceObject?.districtIds && this.referenceObject?.provinceIds) this.apiCommuneByStore()
      else {
        this.viewCsSelect.optionList = [{
          value: 0,
          label: 'Vui lòng chọn quận/huyện trước'
        }]
        this.viewCsSelect.checkDisable = (o) => true
      }
      break
    case AddressSelectorTypes.districtStore:
      if (this.referenceObject?.provinceIds) this.apiDistrictByStore()
      else {
        this.viewCsSelect.optionList = [{
          value: 0,
          label: 'Vui lòng chọn tỉnh thành trước'
        }]
        this.viewCsSelect.checkDisable = (o) => true
      }
      break
    case AddressSelectorTypes.provinceStore:
      if (this.referenceObject?.areaId) this.apiProvinceByStore()
      else {
        this.viewCsSelect.optionList = [{
          value: 0,
          label: 'Vui lòng chọn vùng trước'
        }]
        this.viewCsSelect.checkDisable = (o) => true
      }
      break
    }
  }

  vssUiSelectAddressConfig: configAddressSelectModel

  constructor(
    private control: NgControl,
    private viewCsSelect: CsSelectTableComponent,
    vssUiConfig: VssUiConfig
  ) {
    this.vssUiSelectAddressConfig = vssUiConfig.configAddressSelectBox || {}
  }

  ngOnInit() {
    if (this.addressType == AddressSelectorTypes.country) {
      this.setupApiCountry()
    } else if (this.addressType == AddressSelectorTypes.areaStore) {
      this.apiAreaByStore()
    }
  }

  _progressData(resp: any[]) {
    this.viewCsSelect.isLoading = false
    this.viewCsSelect.getOptionsApi = undefined
    this.viewCsSelect.optionList = resp
    this.viewCsSelect.options = resp
  }

  setupApiCountry() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.country?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
      }
    )
  }

  setupApiProvince() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.province?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
        this.viewCsSelect.onSearch('')
      }
    )
  }

  setupApiDistrict() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.district?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
        this.viewCsSelect.onSearch('')
      }
    )
  }

  setupApiCommuneId() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.commune?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
        this.viewCsSelect.onSearch('')
      }
    )
  }

  apiAreaByStore() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.areaStore?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
        this.viewCsSelect.onSearch('')
      }
    )
  }

  apiProvinceByStore() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.provinceStore?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
        this.viewCsSelect.onSearch('')
      }
    )
  }

  apiDistrictByStore() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.districtStore?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
        this.viewCsSelect.onSearch('')
      }
    )
  }

  apiCommuneByStore() {
    this.viewCsSelect.isLoading = true
    this.vssUiSelectAddressConfig?.communeStore?.apiGetOptions({
      ...this.referenceObject,
      referenceId: this.referenceId
    })?.subscribe(
      res => {
        this._progressData(res)
        this.viewCsSelect.onSearch('')
      }
    )
  }

}
